export class Filter {
  constructor({
    id,
    title,
    headers = [],
    schedule = {},
    breakdownByInvoice,
    contentType,
    renamedHeaders,
    filter = {},
    entity,
    isShared = true,
  }) {
    this.id = id;
    this.title = title;
    this.headers = headers;
    this.schedule = schedule;
    this.breakdownByInvoice = breakdownByInvoice;
    this.contentType = contentType;
    this.renamedHeaders = renamedHeaders;
    this.filter = filter;
    this.type = entity;
    this.isShared = isShared;
  }
}
